export const FETCH_TICKET = 'FETCH_TICKET';
export const SET_TICKET_LOADING = 'SET_TICKET_LOADING';
export const SET_TICKET = 'SET_TICKET';
export const GET_TICKET = 'GET_TICKET';
export const UPDATE_TICKET = 'UPDATE_TICKET';
